// export const environment = {
//   production: false,
//   // ----- API ----- //
//   apiURL: 'https://gokuridevapis.azure-api.net/GOKURI-Dev/v2',
//   apiURLGeneral: 'https://gokuridevapis.azure-api.net/GOKURI-Dev-General/v1',
//   // ----- MsalModule ----- //
//   redirectUri: 'https://gokuridevwebhosting.z11.web.core.windows.net',
//   postLogoutRedirectUri: 'https://gokuridevwebhosting.z11.web.core.windows.net',
//   clientID: '92dfae78-fe1e-47de-98e3-1f4a7f86e1eb',
//   authorityDomain: 'gokuridev.b2clogin.com',
//   authority: 'https://gokuridev.b2clogin.com/tfp/gokuridev.onmicrosoft.com/B2C_1_gokuridev_loginOnly',
//   authorityReset: 'https://gokuridev.b2clogin.com/tfp/gokuridev.onmicrosoft.com/B2C_1_gokuridev_password_reset',
//   b2cScopes: ['https://graph.microsoft.com/offline_access'],
//   scopes: ['openid', 'offline_access'],
//   functionKey: "sMbie8wyhEajY5EMdesMSJ/bW09JX3lDmHhyb5GhKNliPRGcwmVIZA=="
// };

import { getRedirectUri } from "../app/utils";

export const environment = {
  production: false,
  // ----- MsalModule ----- //
  //redirectUri: 'https://gokuridevwebhosting.z11.web.core.windows.net/',
  redirectUri: getRedirectUri(),
  //postLogoutRedirectUri: 'https://gokuridevwebhosting.z11.web.core.windows.net/',
  postLogoutRedirectUri: getRedirectUri(),
  clientID: '92dfae78-fe1e-47de-98e3-1f4a7f86e1eb',
  // b2cScopes: ['https://graph.microsoft.com/offline_access'],
  // scopes: ['openid', 'offline_access'],
  functionKey: "sMbie8wyhEajY5EMdesMSJ/bW09JX3lDmHhyb5GhKNliPRGcwmVIZA=="
};
